import { MonthProps } from "../Types";

export const DB: MonthProps[] = [
  {
    month: "Янв, 21",
    content: {
      movies: [
        "Wonder Woman 1984",
        "В скорлупе",
        "Необычный цыпленок",
        "Чип и Дейл",
        "Все не так",
        "Два бурундука и одна мисс",
        "Соперники",
        "Запас на зиму",
        "Испорченный отдых",
        "Любители игрушек",
        "Верхом на ветке",
        "Кукурузные хлопья",
        "Дональд - яблочная сердцевина",
        "Работа за орехи",
        "Сражение с драконом",
        "На дереве",
        "Завтрак для троих",
        "Пища для вражды",
        "Klaus",
        "Проект Анна Николаевна. Спецвыпуск",
        "Love and Monsters",
        "Ночь перед Рождеством",
      ],
      tv_shows: [
        "Рождественская история (1st)",
        "Wayne (1st)",
        "Дедушка (mini)",
        "Как извести любовницу за 7 дней (mini)",
      ],
      comics: [
        "Лига Справедливости. Тайное общество",
        "Лига Справедливости. Дарксайд",
        "Бэтмен. Мистер Фриз",
        "Бэтмен. Список",
        "Бэтмен. Психушка Джокера. Ядовитый Плющ",
        "Бэтмен. Психушка Джокера. Двуликий",
        "Бэтмен. Тёмный рыцарь. Легенды. Санктум",
        "Бэтмен. Тёмный рыцарь. Легенды. Образы",
        "Бэтмен. Detective Comics. И хрюкотали зелюки",
        "Бэтмен. Санта-Кляус едет в город",
        "Бэтмен. Приключения. Новогодний спецвыпуск",
        "Бэтгерл. Приключения. Рождественский беспредел",
      ],
      games: [
        { title: "11-11: Memories Retold", perfect: false },
        { title: "In Verbis Virtus", perfect: false },
        { title: "Neighbors Back from Hell", perfect: true },
      ],
    },
  },
  {
    month: "Фев, 21",
    content: {
      movies: [
        "Аванпост",
        "Сказания Средиземноморья",
        "Midnight Sky",
        "Django Unchained",
        "The Revenant",
        "Ведьмина служба доставки",
        "Outsider",
        "Gangs of New York",
        "News of the World",
      ],
      tv_shows: ["Cobra Kai (3rd)", "The Watch (1st)", "Топи (1nd)"],
      comics: [
        "Бэтмен. Харли Квинн",
        "Харли Квинн. Да здравствует Харливуд",
        "Бэтмен. Убойная прогулка",
      ],
      games: [
        { title: "We Were Here", perfect: true },
        { title: "Sniper Elite: Nazi Zombie Army 2", perfect: false },
        { title: "BIT.TRIP RUNNER", perfect: false },
      ],
    },
  },
  {
    month: "Мар, 21",
    content: {
      movies: [
        "Croods 2",
        "Outside the Wire",
        "Withes",
        "Highwaymen",
        "Лига Справедливости Зака Снайдера",
        "Годзилла против Конга",
      ],
      tv_shows: ["Vikings (6th)", "The Expanse (5th)", "Snowpiercer (2nd)"],
      comics: [
        "Бэтмен. Ночь Пингвина",
        "Бэтмен. Разговор на двоих",
        "Бэтмен. Такая типа семья",
        "Бэтмен. Жатва",
        "Бэтмен. Укус акулы",
        "Бэтмен. Вопрос доверия",
      ],
      games: [{ title: "Warhammer: Vermintide 2", perfect: false }],
    },
  },
  {
    month: "Апр, 21",
    content: {
      movies: [
        "Pacific Rim",
        "Godzilla (1998)",
        "Родные",
        "Охотник на монстров",
        "Greenland",
        "The Fast and the Furious ",
      ],
      comics: [
        "Бэтмен. Психушка Джокера. Пингвин",
        "Бэтмен. Леденящий ужас",
        "Болотная тварь. Время святых",
        "Боун. Книга 9",
      ],
      games: [
        { title: "Left 4 Dead 2", perfect: false },
        { title: "Spyro Reignited Trilogy", perfect: false },
      ],
    },
  },
  {
    month: "Май, 21",
    content: {
      movies: [
        "Mummy",
        "Mummy Returns",
        "А зори здесь тихие",
        "Hitman's Bodyguard",
        "Pacifix Rim 2",
        "Форсаж 9",
      ],
      tv_shows: [
        "Танцы (1st)",
        "Жуки (2nd)",
        "Чикатило (1st)",
        "Вампиры средней полосы (1st)",
        "Ивановы-Ивановы (5th)",
        "Happy End (1st)",
      ],
      games: [
        { title: "Ghostrunner", perfect: false },
        { title: "We Were Here Too", perfect: false },
      ],
    },
  },
  {
    month: "Июн, 21",
    content: {
      movies: [
        "The Lord of the Rings: The Fellowship of the Ring",
        "The Lord of the Rings: Two Towers",
        "The Lord of the Rings: The Return og the King",
        "Телохранитель жены киллера",
        "Гнев человеческий",
      ],
    },
  },
  {
    month: "Июль, 21",
    content: {
      movies: ["Bad Boys"],
      tv_shows: ["Пищеблок (1st)", "Sweet Tooth (1st)"],
    },
  },
  {
    month: "Авг, 21",
    content: {
      movies: [
        "Bad Boys 2",
        "Bad Boys 3",
        "Pirates Of The Caribbean: The Curse of the Black Pearl",
      ],
      comics: ["Новые Люди Икс. Том 5. Одним меньше"],
      games: [
        { title: "Nephise: Ascension", perfect: true },
        { title: "Zenko: A Fox Tale", perfect: false },
        { title: "Strange Brigade", perfect: false },
      ],
    },
  },
  {
    month: "Сен, 21",
    content: {
      movies: [
        "The Witcher: Nightmare of the Wolf ",
        "Kingdom: Ashin of the North",
        "Pirates Of The Caribbean: Dead Man's Chest",
        "Pirates Of The Caribbean: At World's End",
        "Kate",
        "Army of the Dead",
      ],
      tv_shows: ["Lucifer ((5/2)th, 6th)", "Sex Educations (3rd)"],
      comics: [
        "Каратель MAX. Рождение",
        "Бессмертный Железный Кулак. Том 1",
        "Бессмертный Железный Кулак. Том 2",
      ],
      games: [{ title: "Tok", perfect: true }],
    },
  },
  {
    month: "Окт, 21",
    content: {
      movies: ["Веном 2"],
      tv_shows: ["The North Water"],
      comics: [
        "Бессмертный Железный Кулак. Том 3",
        "Настоящие охотники за приведениями",
        "Блюз дворовых собак",
        "Кейдж",
      ],
    },
  },
  {
    month: "Нов, 21",
    content: {
      tv_shows: [
        "Squid Game (1st)",
        "Проект Анна Николаевна (2nd)",
        "Трудные подростки (3rd)",
      ],
      games: [
        { title: "Batman: Arkham City", perfect: true },
        { title: "Human: Fall Flat", perfect: true },
        { title: "Kingdom Classic", perfect: false },
        { title: "Pluviophile", perfect: true },
        { title: "Snake Force", perfect: true },
        { title: "Drizzlepath", perfect: false },
        { title: "Bottle", perfect: true },
      ],
    },
  },
  {
    month: "Дек, 21",
    content: {
      movies: [
        "Человек-паук: Нет пути домой",
        "Погребальные байки",
        "Братья",
        "Ворошиловский стрелок",
      ],
      tv_shows: ["Патриот (2nd)"],
      games: [
        { title: "Aragami", perfect: false },
        { title: "Drizzlepath: Deja Vu", perfect: true },
      ],
    },
  },
  {
    month: "Янв, 22",
    content: {
      movies: [
        "Последний богатырь. Корень зла",
        "Девчата",
        "Хоббит. Пустошь Смауга",
        "Хоббит. Битва пяти воинств",
        "Ледниковый период",
      ],
      tv_shows: [
        "Плохая дочь (мини)",
        "Любимые женщины Казановы (мини)",
        "Witcher S2",
        "Форт Боярд S8",
        "Аркейн S1",
      ],
      games: [
        { title: "Assassin's Creed Unity", perfect: false },
        { title: "Mirror's Edge", perfect: false },
        { title: "Injustice 2", perfect: false },
        { title: "God of War", perfect: false },
      ],
    },
  },
  {
    month: "Фев, 22",
    content: {
      movies: [
        "Raya and the Last Dragon",
        "Spider-man. Into the Spider-verse",
        "Подсолнух",
        "Огонь",
      ],
      tv_shows: ["WandaVision S1", "Голяк S3"],
      games: [{ title: "Marvel Spider-Man. Miles Morales", perfect: false }],
    },
  },
  {
    month: "Мар, 22",
    content: {
      tv_shows: ["Why women kill S2"],
      games: [{ title: "Marvel Spider-Man", perfect: false }],
      books: ["Живи как кот"],
    },
  },
  {
    month: "Апр, 22",
    content: {
      movies: [
        "Большой ух",
        "The Suicide Squad",
        "Troy",
        "Shang-Chi and the Legend of the Ten Rings",
      ],
      tv_shows: ["Домовенок Кузя"],
      comics: ["Отряд Икс. Том 3"],
      games: [{ title: "Mass Effect 2 LE", perfect: false }],
    },
  },
  {
    month: "Май, 22",
    content: {
      movies: ["Зачинщики", "Маленькие чудовища", "Jungle Cruise", "Free Guy"],
      tv_shows: ["Game of Thrones. S1"],
      comics: ["Дэдпул против Карателя"],
      games: [{ title: "Star Wars Jedi: Fallen Order", perfect: false }],
    },
  },
  {
    month: "Июн, 22",
    content: {
      movies: [
        "Mortal Kombat (2021)",
        "Fantastic Beasts: The Secrets of Dumbledore",
        "The Village",
        "Cruella",
        "Dune. Part 1",
        "Doctor Strange in the Multiverse of Madness",
      ],
      games: [{ title: "", perfect: false }],
    },
  },
  {
    month: "Июль, 22",
    content: {
      movies: ["Sing", "Sing 2", "Jurassic World: Dominion"],
      tv_shows: ["Нулевой пациент. S1", "Loki. S1"],
      games: [{ title: "Guardians of the Galaxy", perfect: false }],
    },
  },
  {
    month: "Авг, 22",
    content: {
      movies: ["Prey", "Black Widow", "Boss Level"],
      tv_shows: [
        "Locke & key. S1-2",
        "Love, death and robots. S3",
        "The Falcon and The Winter Soldier. S1",
      ],
      games: [{ title: "InFamos: Secon Son (PS5)", perfect: false }],
    },
  },
  {
    month: "Сен, 22",
    content: {
      movies: ["The Batman 2022", "Arrival", "Ready or Not"],
      tv_shows: [
        "Locke & key. S3",
        "Vinland Saga. S1",
        "Invincible. S1",
        "Goblin Slayer. S1",
        "Hawkeye. S1",
      ],
      comics: ["Kingsman. Красный алмаз"],
      games: [{ title: "InFamos: Secon Son (PS5)", perfect: false }],
    },
  },
  {
    month: "Окт, 22",
    content: {
      movies: ["Rapa Nui"],
      tv_shows: ["The Boys. S3", "I am Groot. S1"],
    },
  },
  {
    month: "Нов, 22",
    content: {
      tv_shows: ["Primal. S2", "Star Wars: Visions. S1"],
    },
  },
  {
    month: "Дек, 22",
    content: {
      movies: ["Thor. Love and Thunder", "Непослушник"],
      tv_shows: ["The Expanse. S6"],
      games: [
        { title: "The Order 1886 (PS5)", perfect: false },
        { title: "Far Cry 3. Blood Dragon", perfect: false },
        { title: "Little Nightmares", perfect: false },
        { title: "Homo Evolution (Android)", perfect: false },
        { title: "Uncharted 4: A Thief's End (PS5)", perfect: false },
      ],
    },
  },
  {
    month: "Янв, 23",
    content: {
      movies: [
        "Harry Potter and the Philosopher's Stone",
        "Harry Potter and the Chamber of Secrets",
        "Harry Potter and the Prisoner of Azkaban",
        "Harry Potter and the Goblet of Fire",
        "Аватар: Путь воды",
      ],
      tv_shows: ["Wednesday S1", "Чикатило S2"],
      comics: ["Гру. Том 1"],
    },
  },
  {
    month: "Фев, 23",
    content: {
      movies: [
        "Шоугерлз",
        "Пара из будущего",
        "Вышка",
        "Harry Potter and the Order of the Phoenix",
      ],
      tv_shows: ["Жуки. 3 сезон", "Вампиры средней полосы. 2 сезон"],
    },
  },
  {
    month: "Мар, 23",
    content: {
      movies: [
        "Трям! Здравствуйте",
        "Зимняя сказка",
        "Осенние корабли",
        "Удивительная бочка",
        "По дороге с облаками",
        "Подарок для Слона",
        "Клад",
        "Мешок яблок",
        "Harry Potter and the Half-Blood Prince",
        "Harry Potter and the Deathly Hallows: Part I",
        "Harry Potter and the Deathly Hallows: Part II",
      ],
      tv_shows: ["Территория. 2 сезон", "Приключения Лоло и Пепе"],
      comics: [
        "Пол Поуп. Боевой парень",
        "Вселенная Marvel против Карателя",
        "Каратель против Меченого",
        "Невероятный Халк и Существо: Большие перемены",
        "Наши столкновения со злом",
        "Фальконспир",
      ],
      games: [{ title: "Limbo" }, { title: "A Way Out" }],
    },
  },
  {
    month: "Апр, 23",
    content: {
      tv_shows: ["House of the Dragon (1 сезон)"],
      comics: ["Чёрный Молот. Эра Рока II"],
    },
  },
  {
    month: "Май, 23",
    content: {
      tv_shows: ["Полярный (2 сезон)", "Ольга (4 сезон)"],
      games: [{ title: "We Were Here Together" }],
    },
  },
  {
    month: "Июн, 23",
    content: {
      movies: [
        "Dungeon and Dragons: Honor among thieves",
        "Puss in Boots: The Last Wish",
      ],
      tv_shows: ["Black Mirror S6"],
    },
  },
  {
    month: "Июль, 23",
    content: {
      movies: ["Бахубали. Начало", "Бахубали. Завершение"],
      tv_shows: [
        "Окнутые люди",
        "The Book of Boba Fett 1 сезон",
        "The Mandalorian 3 сезон",
      ],
      comics: ["Звери с бренного холма", "47 ронинов", "Картон"],
    },
  },
  {
    month: "Авг, 23",
    content: {
      tv_shows: ["Последнее королевство 5 сезон"],
    },
  },
  {
    month: "Сен, 23",
    content: {
      movies: ["7 королей должны умереть"],
      tv_shows: ["Пишеблок 2 сезон"],
      games: [{ title: "God of War Ragnarök", perfect: true }],
    },
  },
  {
    month: "Окт, 23",
    content: {
      movies: ["Madagascar"],
      tv_shows: ["Разрешите обратиться (1 сезон)"],
    },
  },
  {
    month: "Нов, 23",
    content: {
      movies: [
        "John Wick 4",
        "Мегалодон",
        "Три мушкетера (2023,  Великобритания)",
        "Вальдо",
        "Бандит",
      ],
      tv_shows: [
        "Два холма (2 сезона)",
        "Кибердеревня (1 сезон)",
        "Оливье и роботы (1 сезон)",
      ],
      comics: ["God of War", "Легенда о волках"],
      games: [{ title: "Bottle: Pilgrim Redux" }],
      books: [
        "История с кладбищем",
        "Варкрафт. Дуротан",
        "Хватит быть славным парнем!",
      ],
    },
  },
  {
    month: "Дек, 23",
    content: {
      movies: [
        "The Best Exotic Hotel Merigold",
        "The Second Best Exotic Hotel Merigold",
        "Мамочки",
        "Ягуар",
        "Три мушкетёра: Д'Артаньян",
      ],
      tv_shows: ["Волшебный участок (1 сезон)"],
      comics: ["Баффи - истребительница вампиров. Книга 1"],

      books: ["Хоббит"],
      audiobooks: ["Плутония"],
    },
  },
  {
    month: "Янв, 24",
    content: {
      movies: [
        "Холоп 2",
        "По щучьему велению",
        "Майор Гром. Чумной доктор",
        "Неудержимые 4",
        "Королевство обезьян",
      ],
      tv_shows: [
        "Лунный рыцарь (1 сезон)",
        "Звёздные войны. Сказания о джедаях (1 сезон)",
      ],
      comics: ["Баффи - истребительница вампиров. Книга 2"],
      games: [{ title: "Hidden Through Time" }, { title: "Hogwarts Legacy" }],
      books: ["Ведьмак. Час Презрения"],
    },
  },
  {
    month: "Фев, 24",
    content: {
      movies: ["Fast 10", "Black Adam", "Синий жук"],
      books: ["Ведьмак. Крещение огнём"],
      audiobooks: [
        "Любовь к жизни (Джек Лондон)",
        "Рассказы южных морей (Джек Лондон)",
        "Илья Муромец и Соловей-разбойник ",
        "Смертельная рубашка (Джек Лондон)",
        "Песнь о Вещем Олеге (Александр Пушкин)",
        "После бала (Лев Толстой)",
        "Станционный смотритель (Александр Пушкин)",
        "Повесть о том, как мужик двух генералов прокормил (Салтыков-Щедрин)",
        "Зелёная лампа (Грин)",
        "Человек в футляре (Чехов)",
        "Песня про царя Ивана Васильевича, молодого опричника и удалого купца Калашникова (Лермонтов)",
        "Мальчики (Чехов)",
        "Скрипка Ротшильда (Чехов)",
      ],
    },
  },
  {
    month: "Мар, 24",
    content: {
      comics: ["Веном. Духи возмездия"],
      games: [
        { title: "100 March Cats", perfect: true },
        { title: "100 Dino Cats", perfect: true },
        { title: "100 Asian Cats", perfect: true },
        { title: "100 Ninja Cats", perfect: true },
        { title: "100 Capitalism Cats", perfect: true },
      ],
      books: ["Ведьмак. Башня ласточки"],
      audiobooks: [
        "Зойкина квартира (Михаил Булгаков)",
        "Когда боги смеются (Джек Лондон)",
        "Повесть о Лесах (Константин Паустовский)",
      ],
    },
  },
  {
    month: "Апр, 24",
    content: {
      tv_shows: ["Монарх. Наследник монстров (1 сезон)"],
      comics: [
        "One-punch Man. Книга 10",
        "One-punch Man. Книга 11",
        "One-punch Man. Книга 12",
        "One-punch Man. Книга 13",
        "One-punch Man. Книга 14",
      ],
      books: [
        "Ведьмак. Владычица озера",
        "Ведьмак. Дорога без возврата",
        "Ведьмак. Что-то кончается, что-то начинается",
        "Музыканты",
        "Золотой полдень",
        "Maladie",
      ],
    },
  },
  {
    month: "Май, 24",
    content: {
      comics: ["Клинок бессмертного. Книга 1"],
      games: [{ title: "100 Christmas Cats", perfect: true }],
      books: ["Варкрафт. Рождение орды"],
    },
  },
  {
    month: "Июн, 24",
    content: {
      movies: [
        "Godzilla x Kong: The New Empire",
        "Three Thousand Years Of Longing",
        "Rise Of The Planets Of Apes",
        "The King's Man",
        "Максим Перепелица",
      ],
      comics: ["Нуар. Палп"],
      games: [
        { title: "100 Aliens Cats", perfect: true },
        { title: "100 Space Cats", perfect: true },
      ],
      books: ["Ведьма за границей (Терри Пратчетт)"],
    },
  },
  {
    month: "Июль, 24",
    content: {
      movies: [
        "Dawn Of The Planet Of The Apes",
        "War for the Planet of the Apes",
        "Бременские музыканты (2024)",
        "Летучий корабль (2024)",
        "Бременские музыканты",
        "По следам Бременских музыкантов",
        "Летучий корабль",
      ],
      tv_shows: ["Великий Тихий океан (5 серий)"],
      games: [
        { title: "Ghost Of Tsushima", perfect: true },
        { title: "Looking For Cats In a Badly Drawn City", perfect: true },
        { title: "Cat Search In The Wild West" },
        { title: "Dragon's Lair" },
      ],
      books: [
        "Птицы на кормушуке (Василий Вишневский)",
        "Ведьмак. Сезон гроз (Анджей Сапковский)",
      ],
    },
  },
  {
    month: "Авг, 24",
    content: {
      movies: [
        "Meg 2: The Trench",
        "Бэтмен против Черепашек-ниндзя",
        "Муми-тролль и другие",
        "Муми-тролль и комета",
        "Муми-тролль и комета: Путь домой",
        "Мумми-дол: Всё дело в шляпе",
        "Мумми-дол: Лето в Муми-доле",
        "Мумми-дол: В Муми-дол приходит осень",
        "Неведомая Россия",
        "Гриб: Паутина жизни",
        "Король леса",
      ],
      comics: [
        "Эльф не может похудеть. Том 2",
        "Эльф не может похудеть. Том 3",
        "Эльф не может похудеть. Том 4",
        "Эльф не может похудеть. Том 5",
        "Еретик",
      ],
      games: [
        { title: "Marvel's Spider-Man 2", perfect: true },
        { title: "Looking For Cats In a Badly Drawn Forest", perfect: true },
      ],
      audiobooks: [
        "Глен Кук. Черный отряд",
        "Леонид Андреев. Кусака",
        "Владимир Мономах. Получение",
        "Артур Конан Дойл. Маркотова бездна",
        "Виктор Пелевин. Who by fire",
        "Джордж Оруэл. Скотный двор",
      ],
    },
  },
  {
    month: "Сен, 24",
    content: {
      tv_shows: ["Арт и факт. 1 сезон"],
      audiobooks: ["Эрест Сетон-Томпсон. Рассказы о животных"],
      books: [
        "Вячеслав Грацкий. Заговор Древних",
        "Red Dead Redemption. Хорошая, плохая, культовая. Рождение вестерна от Rockstar Games",
      ],
    },
  },
  {
    month: "Окт, 24",
    content: {
      movies: ["A Knight Story", "Мартынко"],
      tv_shows: ["His Dark Materials (3 сезон)"],
      comics: ["Убийца гоблинов. Книга 1", "Старик Хоукай"],
      books: ["Роман Попсуев. Битва за Лукоморье. Книга 1"],
      audiobooks: ["Александр Куприн. Суламифь"],
      games: [{ title: "Breadsticks" }, { title: "Oik Memory", perfect: true }],
    },
  },
  {
    month: "Нов, 24",
    content: {
      movies: ["Hot Fuzz"],
      tv_shows: ["The 10th Kingdom (1 сезон)", "Варвары (2 сезон)"],
      comics: [
        "Хэллбой. Семя разрушения. 1 выпуск",
        "Хэллбой и БРПД. Долгая ночь на станции Голоски",
        "Хэллбой и БРПД. Зверь из Варгу",
        "Удивительный волшебник из страны Оз",
      ],
      books: ["Застава на окраине Империи. Командория 54. Марцин А. Гузек"],
      games: [
        { title: "100 Waiting Cats", perfect: true },
        { title: "Gris" },
        { title: "Hidden Corgi Mansion", perfect: true },
        { title: "Cat Search In The Wild West", perfect: true },
      ],
    },
  },
  {
    month: "Дек, 24",
    content: {
      movies: ["Тайна Третьей планеты", "  Путешествие муравья"],
      tv_shows: ["Красный состав. Антология русского хоррора"],
      comics: ["Клинок Бессмертного. Книга 2"],
      books: ["Граница Империи. Марцин А. Гузек"],
    },
  },
  {
    month: "Янв, 25",
    content: {
      comics: [
        "Убийца гоблинов. Книга 2",
        "Убийца гоблинов. Книга 3",
        "Убийца гоблинов. Книга 4",
        "Убийца гоблинов. Книга 5",
        "Убийца гоблинов. Книга 6",
        "Убийца гоблинов. Книга 7",
        "Убийца гоблинов. Книга 8",
      ],
      audiobooks: [
        "Константин Паустовский. Маленькие повести",
        "Элджернон Блэквуд. Вендиго",
        "Вильгельм Гауф. Карлик Нос",
        "Марк Твен. Принц и нищий",
      ],
      games: [{ title: "Assemble with care", perfect: true }],
    },
  },
  {
    month: "Фев, 25",
    content: {
      comics: ["Убийца гоблинов. Книга 9", "Убийца гоблинов. Книга 10"],
      audiobooks: ["12 подвигов Геракла"],
      books: ["Слава Империи (Марцин А. Гузек)"],
    },
  },
  {
    month: "Мар, 25",
    content: {
      comics: [
        "Конан. Змеиная война",
        "Могучие Рейнджеры. Год первый",
        "Могучие Рейнджеры. 13-23",
        "Могучие Рейнджеры. Расколотый грид",
        "Могучие Рейнджеры. За гранью грида",
      ],
      books: ["К. Л. Вернер - Проклятие Гарма"],
    },
  },
  {
    month: "Апр, 25",
    content: {
      comics: [
        "Долина червя",
        "Конан Варвар. Пришествие Конана",
        "Конан Варвар. Тень Стервятника",
      ],
      books: ["Марсианин. Энди Вейр"],
      audiobooks: [
        "Байки деревенского вампира. Клим Ерёменко",
        "Байки деревенского оборотня. Артём Схронов",
        "Волчий объект. Майк Гелприн",
        "Деревня оборотней. Гавриил Блаженный",
        "Путь оборотня",
      ],
    },
  },
  {
    month: "Май, 25",
    content: {
      comics: ["Кафе Бессонница", "Кром"],
      audiobooks: [
        "Волкоглав. Роберт Говард",
        "Воткнутый нож",
        "Дым деревень",
        "Багровая луна. Максим Кабир",
        "Сосед. Любовь Богачёва",
        "Оборотень бузулукского леса. Леонтьев Д.",
        "Возвращение оборотней. Гавриил Блаженный",
      ],
    },
  },
  {
    month: "Июн, 25",
    content: {
      comics: [
        "Приключения мистера Фрога и мисс Мышки",
        "Отряд Икс. Секс + насилие",
        "Хэллбой. Книга 1",
        "Электра. Книга 1",
        "Электра. Книга 2",
      ],
      audiobooks: [
        "Оборотень - этой ночью ты не уснёшь",
        "Самая жуткая таежная история про оборотня",
        "Оборотни в тайге, расправа",
        "Таежная история. Оборотень медведь",
      ],
    },
  },
  {
    month: "Июл, 25",
    content: {
      comics: [
        "Гидеон Фолз. Книга 1",
        "Конан-Варвар. Сокровища Гвалура и другие истории",
        "Конан-Варвар. Книга Тота и другие истории",
      ],
      books: [
        "Битва за Лукоморье. Книга 2",
        "Измаил Мухин. Дарвиновский заповедник",
        "Измаил Мухин. Острова жизни",
      ],
    },
  },
  {
    month: "Авг, 25",
    content: {
      comics: [
        "Диптих",
        "Конан Варвар. Полное издание. Книга 1",
        "Конан Варвар. Полное издание. Книга 2",
        "Конан Варвар. Полное издание. Книга 3",
        "Некроманты Зотика",
        "Made in Abbys. Книга 1",
      ],
      audiobooks: ["Джек Лондон. Морской волк"],
    },
  },
  {
    month: "Сен, 25",
    content: {
      comics: [
        "Жизнь и смерть Конана-Варвара",
        "Спаун. Книга 1",
        "Перевал",
        "Леший. Р. Л. Стайн",
        "Плесень предательства",
        "Дилан Дог 6",
        "Дилан Дог 7",
        "Убийца Гоблинов. Книга 11",
        "Убийца Гоблинов. Книга 12",
        "Кольцо Нибелунга",
      ],
      games: [
        { title: "Deus Ex: Human Revolution" },
        { title: "100 Korean Cats", perfect: true },
        { title: "100 Romantic Cats", perfect: true },
        { title: "Severed Steel" },
      ],
      books: ["Птицы Сахалина. Максим Мисюра"],
    },
  },
  {
    month: "Окт, 25",
    content: {
      audiobooks: ["Кавказский пленник. Л. Н. Толстой "],
      games: [{ title: "Cats & Seek. Osaka", perfect: true }],
    },
  },
  {
    month: "Нов, 25",
    content: {
      audiobooks: ["Артур Конан Дойл. Затерянный мир"],
      books: ["Битва за Лукоморье. Книга 3"],
      games: [
        { title: "100 Cats Lost in Thailand Find & Color", perfect: true },
        { title: "Witchfire", perfect: true },
        { title: "100 Forest Cats", perfect: true },
        { title: "Kingdom Classic", perfect: true },
      ],
    },
  },
  {
    month: "Дек, 25",
    content: {
      audiobooks: ["Потомокъ. Кирилл Кощеев, Ирины Волынская"],
      games: [
        { title: "Meow Moments: Celebrating Together", perfect: true },
        { title: "God of War", perfect: true },
        { title: "Far Cry 3 Blood Dragon", perfect: true },
      ],
    },
  },
  {
    month: "Янв, 26",
    content: {
      audiobooks: [
        "Гавриил Блаженный. Месть Аиды",
        "Лайон Спрэг де Камп. Башня гоблинов",
      ],
      books: [
        "Плоский мир Терри Пратчетта. Имаджинариум",
        "Сапковский и др. Век волков",
        "Анджей Сапковский. Ведьмак. Перекрёсток воронов",
      ],
      comics: ["Илья Муромец. Библиотека приключений"],
      games: [
        { title: "Star Wars Jedi: Fallen Order", perfect: true },
        { title: "Bright Memory" },
      ],
      tv_shows: ["Проект Анна Николаевна. 3 сезон", "Звезды. 2 сезон"],
    },
  },
  {
    month: "Фев, 26",
    content: {
      audiobooks: [
        "Лайон Спрэг де Камп. Часы Ираза",
        "Лайон Спрэг де Камп. Корона Ксилара",
        "Лайон Спрэг де Камп. Уважаемый варвар",
      ],
      comics: [
        "Нил Гейман. Книги магии",
        "Убийца гоблинов. Книга 14",
        "Убийца гоблинов. Книга 15",
      ],
      books: [
        "Анастасия Князь. Скиталец",
        "Нелли Кривобокова. Семейная сага. Казахтанский транзит",
      ],
      games: [{ title: "Bright Memory", perfect: true }],
    },
  },
];
